import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { Button, Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SINOLogo from "../assets/images/logo_sino.svg";
import InputForm from "../components/forms/InputForm";
import useAuth from "../services/hooks/useAuth";

const LoginSite = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  // Validierungsschema
  const schema = Joi.object({
    username: Joi.string().required(),
    password: Joi.string().required(),
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
  });

  const onSubmit = async (formData) => {
    console.log("Submit", formData);
    await login(formData.username, formData.password);
    navigate("/");
  };

  return (
    <Row>
      <Col>
        <div
          style={{ maxWidth: "300px", marginLeft: "auto", marginRight: "auto" }}
        >
          <p style={{ textAlign: "center" }}>
            <img src={SINOLogo} style={{ height: "5em" }} alt="Logo" />
          </p>
          <InputForm
            id="username"
            label="Benutzername"
            register={register}
            errors={errors}
          />
          <InputForm
            id="password"
            label="Passwort"
            type="password"
            register={register}
            errors={errors}
          />
          <Button
            variant="warning"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Einloggen
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default LoginSite;
